export default {
  data() {
    return {
      node_dict: {}
    }
  },
  methods: {
    get_tree_obj(ref) {
      let ztreeObj = null
      try{
        ztreeObj = this.$refs[ref].ztreeObj
      }catch (e) {
        ztreeObj = null
      }
      return ztreeObj

    },
    add_nodes(node, children, tree_ref) {
      let treeObj = this.get_tree_obj(tree_ref)
      treeObj.addNodes(node, -1, children)
    },
    loading_node(node, ref) {
      //保存ID 对应图标
      let id = node.id
      this.node_dict[id] = node.iconSkin
      node.iconSkin = 'icon-loading'
      this.get_tree_obj(ref).updateNode(node)

    },
    loaded_node(node, ref) {
      let id = node.id
      let icon = this.node_dict[id]
      node.iconSkin = icon
      this.get_tree_obj(ref).updateNode(node)
    },
    select_tree_node(id, ref, key = "id") {
      let obj = this.get_tree_obj(ref)
      if (!obj) {
        return
      }

      let node = obj.getNodeByParam(key, id)
      if (!node) {
        return
      }
      obj.selectNode(node)
    },

    // 获取指定节点层级路径
      $_get_node_path(target_node){
        var path_list = []
        while (true) {
          if(!target_node || JSON.stringify(target_node) === '{}'){
            break;
          }
          path_list.push(target_node.orginal)
          target_node = target_node.getParentNode()

        }
        path_list.reverse()

        return path_list
      },

      // 获取指定节点的根节点
      $_get_current_root(target_node){
        if(target_node.level === 0){
          return target_node
        }

        var parents_node = target_node.getPath()
        var root_node = parents_node.filter(node => node.level === 0)
        return root_node[0]

      },

        // 展开目标节点的所有父节点,  node 须为ztree节点, self_expand: true 包括节点自身也展开 /  false 只展开节点父节点
        $_expand_target_node_all_parent(ref, node, self_expand){
          let treeObj = this.get_tree_obj(ref)
          if(!treeObj){
            return
          }
          try{
            treeObj.expandAll(false)
            let parent_node = node;
            if(!self_expand){
              parent_node = node.getParentNode()
            }
            while (parent_node){
              treeObj.expandNode(parent_node, true)
              parent_node = parent_node.getParentNode()
            }
          }catch (e) {
            console.log(e)
          }

        },


      $_set_node_checked(ref, checked_data, value_field){
            let tree_obj = this.get_tree_obj(ref);
            if (tree_obj){
              tree_obj.checkAllNodes(false);
              checked_data.map((item =>{
                let node = tree_obj.getNodeByParam(value_field, item[value_field]);
                if (node){
                  tree_obj.checkNode(node, true, true);
                }
              }))
            }
          },



  }
}



// WEBPACK FOOTER //
// ./src/omnis-business/common/mixin/tree_op.js